export default __webpack_public_path__ + "static/media/vitamins.c2452058.png";